import TextImageBanner from "../../common/TextImageBanner";
import ServiceSideSticky from "./ServiceSideSticky";
import ServiceAccoudion from "./ServiceAccordion";
import ServiceDetailSkeleton from "./ServiceDetailSkeleton";
import Centers from "./Centers";
import image from "../../../Assets/Home/MainHome/home3.png"
const Dservice = ({ service, loading, error, serviceData }) => {

  if (error) {
    return (
      <div className="pb-10 familjen-font bg-[#fafafa]">
        <TextImageBanner
          label="Service details"
          bgImage={[
            `${image}`,
            `${image}`,
            `${image}`,
          ]}
        />

        <div className="min-h-[50vh] flex items-center justify-center px-4 py-5">
          <div className="max-w-md w-full text-center animate-fade-in">
            <div className="mx-auto w-20 h-20 bg-red-50 rounded-full flex items-center justify-center mb-6 animate-bounce-gentle">
              <div className="relative">
                <svg className="w-10 h-10 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mb-3">Oops! Something Went Wrong</h2>

            <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6 animate-pulse-soft">
              <p className="text-red-700 text-sm font-medium">
                {error || "We're having trouble loading this content. This might be temporary."}
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <button
                onClick={() => window.location.reload()}
                className="px-6 py-3 bg-red-500 text-white rounded-lg font-medium hover:bg-red-600 transition-all duration-200 transform hover:scale-105 shadow-lg hover:shadow-xl"
              >
                🔄 Try Again
              </button>
              <button
                onClick={() => window.history.back()}
                className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-all duration-200"
              >
                ← Go Back
              </button>
            </div>

            <div className="mt-8 p-4 bg-blue-50 rounded-lg border border-blue-200">
              <p className="text-blue-800 text-sm">
                <strong>Need help?</strong> Contact support at{" "}
                <a href="mailto:support@example.com" className="underline hover:text-blue-600">
                  support@example.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <section className="tracking-wide bg-[#F9FAFB] jakarta-font">
      <TextImageBanner
        label="Service details"
        bgImage={[
          `${image}`,
          `${image}`,
          `${image}`,
        ]}
      />
      <div className="md:mx-10 mx-6 py-10 relative flex flex-col lg:flex-row gap-10">
        <ServiceSideSticky />
        {loading ? (
          <ServiceDetailSkeleton />
        ) : (
          <div className="lg:w-[70%] w-full flex flex-col gap-y-10">
            {
              service?.title === 'Home Sample Collection' && <Centers />
            }
            <article className="flex flex-col gap-y-5">
              <h1 data-aos="fade-up" data-aos-duration="700" className="familjen-font text-3xl md:text-4xl font-semibold mb-4">
                {service?.title}
              </h1>

              <div className="text-justify text-gray-700 leading-relaxed space-y-4">
                {Array.isArray(service?.subDescription) ? (
                  service.subDescription.map((text, idx) => (
                    <p data-aos="fade-up" data-aos-duration="700" key={idx} className="relative">
                      {idx === 0 && (
                        <span
                          className="float-left text-4xl font-bold bg-[#0BB6D9] text-white px-3 py-1 rounded-md mr-3 flex items-center justify-center w-[2.5rem] h-[3rem]"
                          aria-hidden
                        >
                          {text?.charAt(0)?.toUpperCase()}
                        </span>
                      )}
                      {idx === 0 ? text?.slice(1) : text}
                    </p>
                  ))
                ) : (
                  <p>
                    <span data-aos="fade-up" data-aos-duration="700"
                      className="float-left text-4xl font-bold bg-[#0BB6D9] text-white px-3 py-1 rounded-md mr-3 flex items-center justify-center w-[2.5rem] h-[3rem]"
                      aria-hidden
                    >
                      {service?.subDescription?.charAt(0)?.toUpperCase()}
                    </span>
                    {service?.subDescription?.slice(1)}
                  </p>
                )}
              </div>
            </article>

            {/* Features as Testimonials/Benefits Grid */}
            <div className="grid md:grid-cols-2 grid-cols-1 gap-10">
              {Array.isArray(service?.features)
                ? service.features.map(
                  ({ title, description, image }, index) => (
                    <div data-aos="flip-down"
                      key={index}
                      className={`lab-card bg-white rounded-xl shadow-lg px-4 sm:px-3 md:px-5 py-2 sm:py-3 flex flex-col items-start hover:shadow-2xl transition-all duration-300 ease-in-out`}
                    >
                      <article className="flex items-center gap-3 border-b border-gray-300 py-3">
                        <img
                          src={image}
                          alt={title}
                          className="w-14 h-14 card-icon"
                        />
                        <h1 data-aos="fade-up" data-aos-duration="700" className="familjen-font card-title  text-xl font-medium">
                          {title}
                        </h1>
                      </article>
                      <p data-aos="fade-up" data-aos-duration="700" className="text-gray-700 py-3 card-desc text-sm">
                        {description}
                      </p>
                    </div>
                  )
                )
                : null}
            </div>
            <figure data-aos={"zoom-in"} data-aos-duration="700" className="w-full md:h-[480px] h-[210px] rounded-3xl overflow-hidden">
              <img
                className="w-full h-full object-cover object-center"
                src={service?.image}
                alt={service?.title}
              />
            </figure>
            <ServiceAccoudion faqs={service?.faqs || []} />
          </div>
        )}
      </div>
    </section>
  );
};

export default Dservice;
